import { useState } from "react";
import { Link } from "react-router-dom";
import { Check, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, track } from "../lib/api";
import { Reveal } from "./motion";

export default function PackageCard({ pkg, index = 0, highlight = false }) {
  const [loading, setLoading] = useState(false);

  const buyGuide = async () => {
    setLoading(true);
    track("checkout_start", { package_id: pkg.id, price: pkg.price });
    try {
      const { checkout_url } = await api.checkout({
        lookup_key: pkg.lookup_key,
        origin_url: window.location.origin,
      });
      window.location.href = checkout_url;
    } catch {
      toast.error("Checkout couldn't start — please try again in a moment.");
      setLoading(false);
    }
  };

  return (
    <Reveal delay={index * 0.08} className="h-full">
      <article
        id={pkg.id}
        data-testid={`package-card-${pkg.id}`}
        className={`card-soft p-7 sm:p-9 h-full flex flex-col scroll-mt-24 ${highlight ? "ring-2 ring-terra/60 relative" : ""}`}
      >
        {highlight && (
          <span className="absolute -top-3.5 left-7 bg-terra text-white text-xs font-bold px-3.5 py-1.5 rounded-full tracking-wide">
            {pkg.tag}
          </span>
        )}
        {!highlight && <p className="overline-label mb-3">{pkg.tag}</p>}
        <h3 className={`font-serif text-2xl sm:text-[1.7rem] font-medium text-ink leading-snug ${highlight ? "mt-2" : ""}`}>{pkg.name}</h3>
        <p className="mt-3 text-sm text-ink-soft leading-relaxed">{pkg.best_for}</p>
        <p className="mt-5 mb-6">
          <span className="font-serif text-4xl font-medium text-ink">${pkg.price}</span>
          <span className="text-ink-muted text-sm ml-1.5">{pkg.currency}</span>
        </p>
        <ul className="space-y-2.5 mb-8 flex-1">
          {pkg.includes.map((item, i) => (
            <li key={i} className="flex gap-2.5 text-sm text-ink-soft leading-relaxed">
              <Check className="w-4 h-4 text-sage shrink-0 mt-0.5" strokeWidth={2.5} />
              {item}
            </li>
          ))}
        </ul>
        {pkg.cta_type === "checkout" ? (
          <button onClick={buyGuide} disabled={loading} data-testid={`package-cta-${pkg.id}`} className="btn-primary w-full disabled:opacity-70">
            {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : null}
            {pkg.cta}
          </button>
        ) : (
          <Link
            to={pkg.cta_type === "assessment" ? "/sleep-assessment" : "/book-a-call"}
            data-testid={`package-cta-${pkg.id}`}
            className={highlight ? "btn-primary w-full" : "btn-secondary w-full"}
            onClick={() => track("package_recommendation", { package_id: pkg.id, source: "support_options_card" })}
          >
            {pkg.cta}
          </Link>
        )}
      </article>
    </Reveal>
  );
}
